import { HttpHeaders } from '@angular/common/http';

export class ApiRequestOptions
{
  headers: HttpHeaders;
}
